import { render, staticRenderFns } from "./errorCorrectionHistory.vue?vue&type=template&id=2e4f8c9b&scoped=true&"
import script from "./errorCorrectionHistory.vue?vue&type=script&lang=js&"
export * from "./errorCorrectionHistory.vue?vue&type=script&lang=js&"
import style0 from "./errorCorrectionHistory.vue?vue&type=style&index=0&id=2e4f8c9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4f8c9b",
  null
  
)

export default component.exports